import { Injectable } from '@angular/core';
import { ConsentGroupName, ConsentServiceName } from 'libs/shared/src/models';
import { BaseScript } from '../base.script';

@Injectable({
  providedIn: 'root'
})
export class ElfsightScript extends BaseScript {
  // Properties
  /** The name of the script */
  public name: string = 'Elfsight';
  /** The consent category of the script */
  public consentCategory: ConsentGroupName = 'marketing';
  /** The consent service of the script */
  public consentService: ConsentServiceName = 'elfsight';

  /**
   * Gets the attributes for the script element.
   * @returns A record of attributes for the script element.
   */
  public getScriptAttributes(): Record<string, string> {
    return {
      async: 'true',
      defer: 'true'
    };
  }

  /**
   * Gets the script ID.
   * @returns The script ID.
   */
  public getScriptId(): string {
    return 'elfsight-script';
  }

  /**
   * Gets the script URL.
   * @returns The script URL.
   */
  public getScriptUrl(): string {
    return 'https://static.elfsight.com/platform/platform.js';
  }
}
